import { fromJS, Map } from 'immutable';

export function request(state) {
    return state
        .setIn([ 'runReport', 'state' ], 'IN_PROGRESS');
}

export function error(state, { errors }) {
    return state
        .setIn([ 'runReport', 'state' ], 'ERROR')
        .setIn([ 'runReport', 'errors' ], fromJS(errors));
}

export function finish(state) {
    return state
        .setIn([ 'runReport', 'state' ], 'FINISHED');
}

export function clear(state) {
    return state
        .set('runReport', Map());
}
